export const getDetailsSectionPath = (id, path) => {
  if (/.*\/details\/.*/.test(path)) {
    const partsOfPath = path.split("/");
    partsOfPath[partsOfPath.length - 1] = id;
    return partsOfPath.join("/");
  } else if (/.*\/details/.test(path)) {
    return `${path}/${id}`;
  } else {
    return null;
  }
};
